import { render, staticRenderFns } from "./UpsertDialog.vue?vue&type=template&id=bc08cdb2&"
import script from "./UpsertDialog.vue?vue&type=script&lang=js&"
export * from "./UpsertDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports